import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./page/login";
import ProtectedRoute from "./components/ProtectedRoute";
import TokenExpirationChecker from "./modal/tokenExpirationChecker";
import NMain from "./page/main";
import Metric from "./page/main/metric";
import CreatePage from "./page/main/createPage";
import HypervisorPage from "./page/main/hypervisorPage";
import DashboardPage from "./page/main/dashboardPage";
import ConfirmModal from "./modal/confirm";
import UserPage from "./page/main/userPage";
import InstancePage from "./page/main/instancePage";
import DiskPage from "./page/main/storagePage";
import WorkingPage from "./page/main/workingPage";
import FtpPage from "./page/main/ftpPage";
import ErrorModal from "modal/error";

const App = () => {
  useEffect(() => {
    document.title = "cmp";

    if (
      window.location.hostname !== "ncmp.ovp.center" &&
      window.location.hostname === "localhost:3000"
    ) {
      window.location.href =
        "https://ncmp.ovp.center" +
        window.location.pathname +
        window.location.search;
    }
  }, []);

  const token = sessionStorage.getItem("access_token");

  return (
    <>
      <BrowserRouter>
        <ConfirmModal />
        <TokenExpirationChecker />
        <ErrorModal />

        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/"
            element={<Navigate to={token ? "/instance" : "/login"} replace />}
          />

          <Route
            element={
              <ProtectedRoute>
                <NMain />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/hypervisor" element={<HypervisorPage />} />
            <Route path="/instance" element={<InstancePage />} />
            <Route path="/metric/*" element={<Metric />} />
            <Route path="/working" element={<WorkingPage />} />
            <Route path="/workingTest" element={<WorkingPage />} />
            <Route path="/create" element={<CreatePage />} />
            <Route path="/user" element={<UserPage />} />
            <Route path="/storage" element={<DiskPage />} />
            <Route path="/ftp" element={<FtpPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/instance" replace />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
